import templateUrl from './timeline-details.html';

export const timelineDetailComponent = {
	templateUrl,
	bindings: {
		details: '<',
	},

	controller: class TimelineDetailComponent {
		constructor($state, TimelineService, toastr, ModalService, $stateParams) {
			'ngInject';
			this.$state = $state;
			this.toastr = toastr;
			this.TimelineService = TimelineService;
			this.modalService = ModalService;
			this.stateParams = $stateParams
		}
		$onInit() {
			this.goTOBack = this.$state.router.globals.current.parentState
		}

		editTimeline() {
			if (this.$state.router.globals.current.parentState === "spouseChecklist") {
				this.$state.go('spouseChecklistEdit', {
					id: this.stateParams.id
				})
			} else {
				this.$state.go('timelineEdit', {
					id: this.stateParams.id
				})
			}

		}
	}
};


// WEBPACK FOOTER //
// ./src/app/components/timeline/timeline-detail/timeline-details.component.js